import {isNotNil} from 'ramda';

import {RelativeFilterConfigBody} from '@dms/api/core';

type RelativeFilterConfigOverrides = Omit<Partial<RelativeFilterConfigBody>, 'sellerType'> & {
  /** Allows injecting legacy RelativeFilterChoice strings in tests. */
  sellerType?: unknown;
};

export function emptyRelativeFilterConfig(
  overrides: RelativeFilterConfigOverrides = {}
): RelativeFilterConfigBody {
  const {sellerType, ...rest} = overrides;
  const config: RelativeFilterConfigBody = {
    year: null,
    mileage: null,
    mileagePct: null,
    power: null,
    powerPct: null,
    price: null,
    pricePct: null,
    featureScore: null,
    trimLevel: null,
    transmission: null,
    fuel: null,
    body: null,
    drive: null,
    vatDeductible: null,
    sellerType: null,
    seats: null,
    radius: null,
    features: null,
    mileageSnapToServerSteps: null,
    mileageMin: null,
    ...rest,
  };

  if (isNotNil(sellerType)) {
    Object.assign(config, {sellerType});
  }

  return config;
}
